import { useState, useEffect, useCallback } from "react";
import backendService from "../services/backendService";

// AckType enum from IoT.DB
const ACK_CLOSE = "Close";
const ACK_DONT_SHOW = "DoNotShow";

// MaintenanceActivityStatus enum from IoT.DB
const STATUS_SCHEDULED = "Scheduled";
const STATUS_IN_PROGRESS = "InProgress";
const STATUS_COMPLETED = "Completed";

export const shouldShowItem = (item) => {
  if (!item) return false;
  if (item.window.status === STATUS_COMPLETED) return false;
  return item.userAckType !== ACK_DONT_SHOW;
};

export const selectItemToShow = (items) => {
  const visible = items.filter(shouldShowItem);
  const inProgress = visible.find((i) => i.window.status === STATUS_IN_PROGRESS);
  if (inProgress) return inProgress;
  return visible
    .filter((i) => i.window.status === STATUS_SCHEDULED)
    .sort((a, b) => new Date(a.window.startDateUtc) - new Date(b.window.startDateUtc))[0] ?? null;
};

const useMaintenanceBanner = () => {
  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    backendService.getActiveMaintenanceWindow([STATUS_SCHEDULED, STATUS_IN_PROGRESS]).then((res) => {
      if (cancelled) return;
      const items = res?.data?.items ?? [];
      const item = selectItemToShow(items);
      setActiveItem(item);
      setVisible(item !== null);
    });
    return () => { cancelled = true; };
  }, []);

  const ack = useCallback(async (ackType) => {
    if (!activeItem) return;
    setVisible(false);
    await backendService.ackMaintenanceWindow(
      activeItem.window.maintenanceWindowGuid,
      ackType
    );
  }, [activeItem]);

  const handleClose = useCallback(() => ack(ACK_CLOSE), [ack]);
  const handleDontShow = useCallback(() => ack(ACK_DONT_SHOW), [ack]);

  return { activeItem, visible, handleClose, handleDontShow };
};

export { ACK_CLOSE, ACK_DONT_SHOW, STATUS_SCHEDULED, STATUS_IN_PROGRESS, STATUS_COMPLETED };
export default useMaintenanceBanner;
